import React from "react"
import AppDialog from "../../../components/Common/AppDialog"

import '../order.css';

const CloseOrder = (props) => {

    return (
        <AppDialog
            open={props.open}
            close={() => props.close()}
            title={'Mark as closed'}
            titleIcon={'complete'}
            positiveTitle={'Close order'}
            positivePress={() => props.submit()}
            negativePress={() => props.close()}
            negativeTitle={'Cancel'}
            width={'30%'}
        >
            <div className="">
                Are you sure you want to close this order?
            </div>
        </AppDialog>
    )
}

export default CloseOrder;